import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import {getAccountResponsibilityService, updateAccountResponsibilityService} from '../../../../redux/actions';

class ManageAccounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountNumber: '',
            showResult: false,
            recordNotFound: false,
            confirmationMessage: '',
            errorMessage: '',
            accountData: {
                velocityCustomer: 'null',
                holdBackOrder: 'null',
                factoryDirect: 'null'
            }
        };
    }

    componentWillMount() {
        const { user: { userDetails } } = this.props.state;
        if (userDetails && !userDetails.isSiteManagementAccess) {
            browserHistory.push('/home');
        }
    }

    handleAccountNumberChange = (e) => {
        this.setState({
            accountNumber: e.target.value,
            showResult: false,
            recordNotFound: false,
            confirmationMessage: ''
        });
    };

    handleSearch = () => {
    const { accountNumber } = this.state;

    if (!accountNumber) {
        this.setState({ errorMessage: 'Please enter Account Number' });
        return;
    }
    const queryString = `requestType=getAccountResponsibility&accountNumber=${accountNumber}`;
        this.props.getAccountResponsibilityService(queryString,
            response => {
                if (response && response.status && response.responseObject) {
                    this.setState({
                        showResult: true,
                        recordNotFound: false,
                        errorMessage: '',
                        accountData: {
                            ...response.responseObject,
                            velocityCustomer:response.responseObject.velocityCustomer ? response.responseObject.velocityCustomer : 'null',
                            holdBackOrder: response.responseObject.holdBackOrder ?response.responseObject.holdBackOrder : 'null',
                            factoryDirect : response.responseObject.factoryDirect ?response.responseObject.factoryDirect : 'null',
                        }
                    });
                } else {
                    this.setState({
                        showResult: true,
                        recordNotFound: true,
                        errorMessage: '',
                         accountData: {
                            accountNumber : accountNumber,
                            allowedCreditTypes: null,
                            applyBulkHold: null,
                            displaySA: null,
                            hdRenoAccount: null,
                            returns: null,
                            showGESKU : null,
                            updatedBy: null,
                            updatedDate: null,
                            velocityCustomer:'null',
                            holdBackOrder: 'null',
                             factoryDirect: 'null',
                        }
                    });
                }} );
    };

    handleDropdownChange = (field, e) => {
        this.setState({
            accountData: {
                ...this.state.accountData,
                [field]: e.target.value
            }
        });
    };

    handleSave = () => {
        const { accountNumber, accountData } = this.state;
        const payload ={
            ...accountData,
            velocityCustomer: accountData.velocityCustomer,
            holdBackOrder: accountData.holdBackOrder, 
            factoryDirect: accountData.factoryDirect,   
        }
        this.props.updateAccountResponsibilityService(payload,'requestType=updateAccountResponsibility', (response) => {
            if (response && response.status) {
                this.setState({
                    confirmationMessage: 'Account updated successfully',
                    errorMessage: ''
                });
            } else {
                this.setState({
                    confirmationMessage: '',
                    errorMessage: 'Update failed. Please try again.'
                });
            }
        });
    };

    render() {
        const {
            accountNumber,
            showResult,
            recordNotFound,
            accountData,
            confirmationMessage
        } = this.state;

        return (
            <div className="push">
                <h1 className="pageTitle">Manage Accounts</h1>

                {/* Search Section */}
                <table className="formTableTypeA">
                    <tbody>
                        <tr>
                            <td style={{width:"13%"}}>Account Number</td>
                            <td style={{width:"0%"}}>
                                <input
                                    type="text"
                                    value={accountNumber}
                                    onChange={this.handleAccountNumberChange}
                                />
                            </td>
                            <td style={{width:"67%"}}>
                                <input
                                    type="button"
                                    className="blueButton uppercase"
                                    value="Search"
                                    onClick={this.handleSearch}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                {recordNotFound && (
                    <p className="bold red">Record not found</p>
                )}

                {showResult && (
                    <div>
                        {confirmationMessage && (
                            <p className="bold blue">{confirmationMessage}</p>
                        )}

                        <table className="dataTable">
                            <thead>
                                <tr>
                                    <th>Account number</th>
                                    <th>Velocity Customer</th>
                                    <th>Hold Backorder</th>
                                    <th>Factory Direct</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{accountNumber}</td>
                                    <td>
                                        <select
                                            value={accountData.velocityCustomer}
                                            onChange={(e) =>
                                                this.handleDropdownChange('velocityCustomer', e)
                                            }
                                        >
                                            <option value="null">null</option>
                                            <option value="Y">Y</option>
                                            <option value="N">N</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            value={accountData.holdBackOrder}
                                            onChange={(e) =>
                                               this.handleDropdownChange('holdBackOrder', e)
                                            }
                                        >
                                            <option value="null">null</option>
                                            <option value="Y">Y</option>
                                            <option value="N">N</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            value={accountData.factoryDirect}
                                            onChange={(e) =>
                                                this.handleDropdownChange('factoryDirect', e)
                                            }
                                        >
                                            <option value="null">null</option>
                                            <option value="Y">Y</option>
                                            <option value="N">N</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                      <div className="push clearfix">
                        <div style={{ float: 'left' }}>
                            <Link to="/siteManagement">Back to Site Management</Link>
                        </div>

                        <div style={{ float: 'right' }}>
                            <input
                                type="button"
                                className="blueButton uppercase"
                                value="Save"
                                onClick={this.handleSave}
                            />
                        </div>
                    </div>
                    </div>
                )}


            </div>
        );
    }
}

const mapStateToProps = (state) => ({ state });
const mapDispatchToProps = (dispatch) => ({
    getAccountResponsibilityService: (queryString, callback) => dispatch(getAccountResponsibilityService(queryString, callback)),
    updateAccountResponsibilityService: (queryString, callback) => dispatch(updateAccountResponsibilityService(queryString, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ManageAccounts);



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/ManageAccounts/index.js